import { useEffect } from 'react'
import UserState from '../state/User'

export type PermissionType =
  | 'ReadProducts' | 'WriteProducts'
  | 'ReadPaymentLinks' | 'WritePaymentLinks'
  | 'ReadCustomers' | 'WriteCustomers'
  | 'ReadInvoices' | 'WriteInvoices'
  | 'ReadCheckoutSessions' | 'WriteCheckoutSessions'
  | 'ReadWebhooks' | 'WriteWebhooks'
  | 'ReadEvents'
  | 'ReadBalance'
  | 'WriteWithdrawal' | 'ReadWithdrawal'
  | 'ReadSubscriptions' | 'WriteSubscriptions'
  | 'ReadDiscountCodes' | 'WriteDiscountCodes'
  | 'ReadAPITokens' | 'WriteAPITokens'
  | 'WriteOrganization'
  | 'WriteRoles' | 'ReadRoles'
  | 'WriteTeam' | 'ReadTeam'
  | 'WritePaymentSessions' | 'ReadPaymentSessions'
  | 'ReadRefunds' | 'WriteRefunds'
  | 'WriteIncompletePayments'
  | 'ReadWithdrawalAccount' | 'WriteWithdrawalAccount'
  | 'WriteAutomation' | 'ReadAutomation'
  | 'WriteDonationLinks' | 'ReadDonationLinks'
  | 'ReadPayments'
  | 'WriteOnramps' | 'ReadOnramps'
  | 'WritePayouts' | 'WriteConfirmPayouts' | 'ReadPayouts'
  | 'ReadVerifications' | 'WriteVerifications' | 'WriteUploadVerifications'
  | 'ReadDeposit'
  | 'ReadDepositAccount' | 'WriteDepositAccount'
  | 'ReadConversion' | 'WriteConversion'
  | 'ReadExternalAccount' | 'WriteExternalAccount'
  | 'ReadPrivateTreasury' | 'WritePrivateTreasury'
  | 'ReadSwap' | 'WriteSwap'

export type PermissionRequirement =
  | PermissionType
  | PermissionType[]
  | { anyOf: PermissionType[] }

export function satisfiesPermission(requirement?: PermissionRequirement): boolean {
  if (requirement !== undefined && !Array.isArray(requirement) && typeof requirement === 'object') {
    return UserState.hasPermission(requirement.anyOf, { requireAll: false })
  }
  return UserState.hasPermission(requirement)
}

export interface UsePermissions {
  has: (...perms: PermissionType[]) => boolean
  hasAny: (...perms: PermissionType[]) => boolean
  isLoaded: boolean
  permissions: Set<string>
}

export function usePermissions(): UsePermissions {
  useEffect(() => {
    void UserState.getUser()
  }, [])

  return {
    has: (...perms) => UserState.hasPermission(perms, { requireAll: true }),
    hasAny: (...perms) => UserState.hasPermission(perms, { requireAll: false }),
    isLoaded: UserState.permissionsLoaded,
    permissions: UserState.permissionSet
  }
}
